export const DEFAULT_AUTO_HIDE_DURATION = 10000;
